module.exports = __webpack_public_path__ + "static/media/zodiac_border.68a7b4c1.png";